<template>
    <div>
        <CommonSpinner v-if="isLoading" />
        <div v-else class="row">
            <div v-if="item" class="col-12">
                <div class="row g-3 justify-content-center">
                    <div class="col-lg-10">
                        <div class="card mb-4">
                            <div class="card-header d-flex justify-content-between align-items-center">
                                <h5 class="card-title mb-0">Opportunity Details</h5>
                            </div>
                            <div class="card-body position-relative">
                                <div class="row g-4">
                                    <div class="col-12">
                                        <div class="d-flex align-items-center">
                                            <img @click="showProfileImg(item.company_logo)"
                                                class="avatar me-3 rounded-circle cursor-pointer" :src="absoluteUrl(item.company_logo)" />
                                            <div>
                                                <label class="small text-muted">Opportunity ID</label>
                                                <p class="mb-0">{{ item.friendly_id }}</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="small text-muted">Title</label>
                                        <p class="mb-0">{{ item.title }}</p>
                                    </div>
                                    <div class="col-lg-6">
                                        <label class="small">Company Name</label>
                                        <h6 class="mb-0">{{ item.company_name }}</h6>
                                    </div>
                                    <div v-if="item.short_description" class="col-12">
                                        <label class="small text-muted">Brief Description </label>
                                        <div v-html="preText(item.short_description)" class="">
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div>
                            <div v-if="item.opportunity_match" >
                                <application-success-card :item="item.opportunity_match" />
                            </div>
                            <div v-else>
                                <application-form 
                                    v-if="!applicationSubmitted "
                                    @closeMe="initializeAll()" :editItem="item"
                                    @formSubmitted="submittedApplication($event)" />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>
<script>

import ApplicationForm from '@/components/forms/ApplicationForm.vue'
import ApplicationSuccessCard from '@/components/cards/ApplicationSuccessCard.vue'

export default {
    name: "application-create",
    components: {
        ApplicationForm,
        ApplicationSuccessCard
    },
    data() {
        return {
            isLoading: false,
            applicationSubmitted: false,
            item: null,
        }
    },
    computed: {
        activeUser() {
            return this.$store.state.AppActiveUser
        },
    },
    methods: {
        async fetchItem(showLoader = true) {
            this.isLoading = showLoader;
            this.$http.get(`/opportunities/${this.$route.params.opportunityId}/show`)
                .then((response) => {
                    this.isLoading = false
                    if (response.data.success) {
                        this.item = response.data.data
                    } else {
                        this.$router.push({ path: '/error-404' })
                    }
                })
        },
        submittedApplication(data){
            Swal.fire({
                icon: 'success',
                title: "Congratulations!",
                html: data.message || '',
                confirmButtonText: "Okay",
            })

            this.applicationSubmitted = true;
            this.fetchItem(false);
        },
        initializeAll() {
        }
    },
    created() {
        this.fetchItem()
    }
}

</script>
<style scoped>

</style>
